type Translate = (key: string, params?: Record<string, unknown>) => string

/*
 * 플레이 그룹 삭제 가능 여부 가드 — 순수 로직(리졸버에서 분리해 단위 테스트 가능).
 * - 도메인 내에 플레이 그룹이 없으면 not-found 로 거절.
 * - 소속 보드(다대다 관계)가 하나라도 있으면 삭제를 차단(고아 관계 방지). 먼저 보드를 제거해야 한다.
 */
export function assertPlayGroupDeletable(playGroup: { boards?: unknown[] } | null | undefined, t: Translate): void {
  if (!playGroup) {
    throw new Error(t('error.play group not found'))
  }
  const boardCount = playGroup.boards?.length ?? 0
  if (boardCount > 0) {
    throw new Error(t('error.play group has boards', { count: boardCount }))
  }
}
